/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Error500() {
  return (
    <div id="internal-server">
      <div class="internal-server">
        <div class="internal-server-500">
          <h1>500</h1>
        </div>
        <h2>We're unable to find out what's happening! </h2>
        <p>We suggest you reload the page or visit later</p>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.location.reload();
          }}>
          Reload Page
        </a>
      </div>
    </div>
  );
}
